import React from 'react';
import { productKeys } from '../../../../utils/productHelpers';

/**
 * Rollover Card component
 * Displays information about an account that is rolling over to a new term
 * @param {{ account: any; products: any[] }} props
 */
const RolloverCard = ({ account, products }) => {
    const product = account.maturity && account.maturity.rolloverAccountProductId
        ? products.find((/** @type {any} */ p) => p.id === account.maturity.rolloverAccountProductId)
        : products.find((/** @type {any} */ p) => p.code === productKeys.FixedRateSaver);

    const rolloverRate = account.maturity && 
        account.maturity.availableRolloverRates && 
        account.maturity.rolloverAccountProductId
        ? account.maturity.availableRolloverRates.find(
            (/** @type {any} */ r) => r.productId === account.maturity.rolloverAccountProductId
          )?.rate || 0
        : 0;

    const displayNtbRate = product && product.rate > rolloverRate;
    const rate = product && displayNtbRate ? product.rate : rolloverRate;
    
    const formattedMaturityDate = account.maturity && account.maturity.maturityDate
        ? new Date(account.maturity.maturityDate).toLocaleDateString('en-GB', { 
            day: 'numeric', 
            month: 'long', 
            year: 'numeric' 
          })
        : '';

    return (
        <div className="account-slide">
            <div className="rollover-card">
                <div className="rollover-card__content">
                    <div className="rollover-card__title">
                        Renewed {product ? product.name : ''} (opening soon)
                    </div>
                    <div className="rollover-card__detail">
                        {displayNtbRate ? (
                            <>
                                <p>
                                    <svg className="rollover-card__check-icon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <circle cx="12" cy="12" r="10" fill="#00204e"/>
                                        <path d="M7 12l3 3 7-7" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                    </svg>
                                    As of today, you'll earn: <b>{rate}%</b> AER*
                                </p>
                                <p>
                                    We'll always offer you our highest rate on the day your account matures. Currently, this is our
                                    rate for new customers, which is higher than the renewal rate we originally offered you.
                                </p>
                            </>
                        ) : (
                            <>
                                <p>
                                    <svg className="rollover-card__check-icon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <circle cx="12" cy="12" r="10" fill="#00204e"/>
                                        <path d="M7 12l3 3 7-7" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                    </svg>
                                    Renewal rate: <b>{rate.toFixed(2)}%</b> AER*
                                </p>
                                <p>
                                    We'll always offer you our highest rate on the day your account matures. Currently, this is
                                    your renewal rate, which is higher than or equal to our rate for new customers.
                                </p>
                            </>
                        )}
                    </div>
                </div>
                <div className="rollover-card__info">
                    Opening on {formattedMaturityDate}
                </div>
            </div>
        </div>
    );
};

export default RolloverCard;
